module.exports = __webpack_public_path__ + "img/電気回路_2_10_4.716cc13e.png";